const getModifiers = (object) => (
  Object.keys(object).reduce((acc, key) => {
    const value = object[key];

    if (value) {
      const name = typeof key === 'string' ? key.trim() : key;
      return acc.concat(name);
    }

    return acc;
  }, [])
);

const addBlockNameToModifiers = (array, blockName) => (
  array.map((modifier) => `${blockName}_${modifier}`)
);

const generateModifiers = (array, blockName) => (
  addBlockNameToModifiers(getModifiers(array), blockName).join(' ')
);

const getAffix = (name, blockName) => (
  name.trim() ? `${blockName}__${name}` : blockName
);

const getFullName = (affix, modifiers) => {
  const { mix, ...rest } = modifiers;
  const string = `${affix} ${generateModifiers(rest, affix)}`;
  return mix ? mix.concat(` ${string}`) : string;
};

const bem = (blockName) => {
  if (typeof blockName !== 'string') {
    throw new Error('Expected type of block name string, but got: ', blockName);
  }

  return (...args) => {
    const [firstArg, secondArg] = args;

    if (typeof firstArg === 'object') {
      return getFullName(blockName, firstArg);
    }

    if (typeof firstArg === 'string') {
      const affix = getAffix(firstArg, blockName);

      if (typeof secondArg === 'object') {
        return getFullName(affix, secondArg);
      }

      return affix;
    }

    return blockName;
  };
};

export default bem;
